<template>
  <div>
    <Head title="Users" />
    <h1>Agents</h1>

    <div class="d-flex justify-content-between mb-3">
      <search-filter v-model="form.search" @reset="reset" />

      <Link class="btn btn-primary" href="/users/create">
        <span>Create</span>
        <span class="hidden md:inline">&nbsp;User</span>
      </Link>
    </div>

    <div class="content-box">
      <table class="table">
        <thead>
          <tr>
          <th>Name</th>
          <th>Agency</th>
          <th>Email</th>
        </tr>
        </thead>
        <tbody>
          <tr v-for="user in users.data" :key="user.id">
            <td>
              <Link :href="`/users/${user.id}/edit`">
                {{ user.first_name }} {{ user.last_name }}
                <icon v-if="user.deleted_at" name="trash" class="flex-shrink-0 ml-2 w-3 h-3 fill-gray-400" />
              </Link>
            </td>
            <td>
              <Link :href="`/users/${user.id}/edit`" tabindex="-1">
                {{ user.agency[0].name }}
              </Link>
            </td>
            <td>
              <Link :href="`/users/${user.id}/edit`" tabindex="-1">
                {{ user.email }}
              </Link>
            </td>
          </tr>
          <tr v-if="users.data.length === 0">
            <td class="px-6 py-4 border-t" colspan="4">No users found.</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import SearchFilter from '@/Shared/SearchFilter'

export default {
  components: {
    Head,
    Icon,
    Link,
    SearchFilter,
  },
  layout: Layout,
  props: {
    filters: Object,
    users: Array,
  },
  data() {
    return {
      form: {
        search: this.filters.search,
        role: this.filters.role,
        trashed: this.filters.trashed,
      },
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get('/users', pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
  },
}
</script>
